import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import helperSpinner from "../../../../helpers/spinner";
import helperNumbers from "../../../../helpers/numbers";
import helperTime from "../../../../helpers/time";
import httpService from "../../../../services/httpServices/httpServices";
import StatusAskCheckout from "./StatusAskCheckout";

export default function ViewAskCheckout() {
  const [askCheckout, setAskCheckout] = useState();
  const params = useParams();
  const askCheckoutID = params.askCheckoutID;

  useEffect(() => {
    getAskCheckout();
  }, []);

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getAskCheckout = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let askCheckout = await sendRequestGetAskCheckout(askCheckoutID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!askCheckout) {
      return;
    }

    setAskCheckout(askCheckout);
  };

  const sendRequestGetAskCheckout = async (askCheckoutID) => {
    const headersRequest = getHeaderRequest();
    let askCheckout;
    try {
      askCheckout = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/marketer/ask-checkout/" +
          askCheckoutID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return askCheckout.data.data;
  };

  const generateAskCheckout = () => {
    let classBadgeStatePage;
    switch (askCheckout.status) {
      case StatusAskCheckout.getStatusAskCheckoutString()[
        StatusAskCheckout.statusAskCheckout.PENDING
      ]:
        classBadgeStatePage = "badge-warning";
        break;
      case StatusAskCheckout.getStatusAskCheckoutString()[
        StatusAskCheckout.statusAskCheckout.PAID
      ]:
        classBadgeStatePage = "badge-info";
        break;
      case StatusAskCheckout.getStatusAskCheckoutString()[
        StatusAskCheckout.statusAskCheckout.REJECT
      ]:
        classBadgeStatePage = "badge-danger";
        break;
    }

    return (
      <div>
        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td
                  colSpan={2}
                  className="text-center"
                  style={{ borderRadius: "25px 25px 0 0" }}
                >
                  اطلاعات وارد شده برای درخواست تسویه حساب
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>شماره درخواست</td>
                <td> {helperNumbers.toPersianNum(askCheckout.id)}</td>
              </tr>
              <tr>
                <td>مبلغ (تومان)</td>
                <td>
                  <label className="letter-spacing-finance-number pl-2">
                    {helperNumbers.toPersianNum(
                      helperNumbers.toFormatFinanceNumber(askCheckout.price)
                    )}
                  </label>
                  <label>تومان</label>
                </td>
              </tr>
              <tr>
                <td>نام بانک </td>
                <td>{askCheckout.bank_name}</td>
              </tr>
              <tr>
                <td>نام مالک حساب</td>
                <td>{askCheckout.owner_account_name}</td>
              </tr>
              <tr>
                <td>شماره حساب بانکی</td>
                <td>{askCheckout.account_number}</td>
              </tr>
              <tr>
                <td>شماره کارت بانکی </td>
                <td>{askCheckout.account_cart_number}</td>
              </tr>
              <tr>
                <td>شماره شبا </td>
                <td>{askCheckout.account_shaba_number}</td>
              </tr>
              <tr>
                <td>وضعیت</td>
                <td>
                  <span className={`badge ${classBadgeStatePage}`}>
                    {askCheckout.status}
                  </span>
                </td>
              </tr>
              {StatusAskCheckout.getStatusAskCheckoutString()[
                StatusAskCheckout.statusAskCheckout.REJECT
              ] == askCheckout.status && (
                <tr>
                  <td>دلیل رد شدن</td>
                  <td> {askCheckout.message}</td>
                </tr>
              )}
              {StatusAskCheckout.getStatusAskCheckoutString()[
                StatusAskCheckout.statusAskCheckout.PAID
              ] == askCheckout.status && (
                <>
                  <tr>
                    <td>عکس رسید پرداخت</td>
                    <td>
                      <a
                        target="_blank"
                        href={askCheckout.receipt_payment_image}
                      >
                        <img
                          className="img-fluid"
                          src={askCheckout.receipt_payment_image}
                        />
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td>تاریخ پرداخت</td>
                    <td>
                      {helperNumbers.toPersianNum(
                        askCheckout.paid_at.split(" ")[1] +
                          " " +
                          helperTime.convertGregorianToJalali(
                            askCheckout.paid_at.split(" ")[0]
                          )
                      )}
                    </td>
                  </tr>
                </>
              )}
              <tr>
                <td>تاریخ درج</td>
                <td>
                  {helperNumbers.toPersianNum(
                    askCheckout.created_at.split(" ")[1] +
                      " " +
                      helperTime.convertGregorianToJalali(
                        askCheckout.created_at.split(" ")[0]
                      )
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="مشاهده وضعیت درخواست تسویه حساب" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="btn btn-primary"
                  to="/marketer/all-ask-checkout"
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {askCheckout && generateAskCheckout()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
